<template>
	<div class='knd-graphic-container'>
		<div class='knd-graphic' ref='money'>
			<Tooltip :tooltip="tooltip" :showTooltip="showTooltip">
				{{master.lasten_labels[this.tooltip?.info.label]}} 
				<div>€{{this.tooltip?.info.value}} per inwoner</div>
			</Tooltip>
			
		</div>

		<div class='knd-container'>
			<div class='knd-fixed-top knd-label-click' v-show="showClickLabel">
				<div>klik op een onderwerp om er meer over te lezen</div>
			</div>
		</div>
		<div class='knd-show-endscreen' v-show="showClickLabel && gemeente.history && gemeente.history.length > 0" 
			v-on:click="showEindscherm">
			<div>
				Alles gelezen wat je interesseerde? 
				<div>Klik hier</div>
			</div>
		</div>
		<div class='knd-fixed-bottom knd-scroll-down' v-show="showScroll">
			<div class='animate-bounce'>
<svg class="knd-pijl" viewBox="0 0 49 82" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2_2)">
<path d="M36.16 64.57L26.05 74.01V27H21.52V73.39L12.08 64.57L9 67.89L24.12 82L39.24 67.89L36.16 64.57Z" fill="white"/>
</g>
<path d="M8.69922 11.4062C8.69922 11.0742 8.64714 10.7812 8.54297 10.5273C8.44531 10.2669 8.26953 10.0326 8.01562 9.82422C7.76823 9.61589 7.42318 9.41732 6.98047 9.22852C6.54427 9.03971 5.99089 8.84766 5.32031 8.65234C4.61719 8.44401 3.98242 8.21289 3.41602 7.95898C2.84961 7.69857 2.36458 7.40234 1.96094 7.07031C1.55729 6.73828 1.24805 6.35742 1.0332 5.92773C0.818359 5.49805 0.710938 5.00651 0.710938 4.45312C0.710938 3.89974 0.82487 3.38867 1.05273 2.91992C1.2806 2.45117 1.60612 2.04427 2.0293 1.69922C2.45898 1.34766 2.97005 1.07422 3.5625 0.878906C4.15495 0.683594 4.81576 0.585938 5.54492 0.585938C6.61263 0.585938 7.51758 0.791016 8.25977 1.20117C9.00846 1.60482 9.57812 2.13542 9.96875 2.79297C10.3594 3.44401 10.5547 4.14062 10.5547 4.88281H8.67969C8.67969 4.34896 8.56576 3.87695 8.33789 3.4668C8.11003 3.05013 7.76497 2.72461 7.30273 2.49023C6.84049 2.24935 6.25456 2.12891 5.54492 2.12891C4.87435 2.12891 4.32096 2.22982 3.88477 2.43164C3.44857 2.63346 3.12305 2.9069 2.9082 3.25195C2.69987 3.59701 2.5957 3.99089 2.5957 4.43359C2.5957 4.73307 2.65755 5.00651 2.78125 5.25391C2.91146 5.49479 3.11003 5.7194 3.37695 5.92773C3.65039 6.13607 3.99544 6.32812 4.41211 6.50391C4.83529 6.67969 5.33984 6.84896 5.92578 7.01172C6.73307 7.23958 7.42969 7.49349 8.01562 7.77344C8.60156 8.05339 9.08333 8.36914 9.46094 8.7207C9.84505 9.06576 10.1283 9.45964 10.3105 9.90234C10.4993 10.3385 10.5938 10.8333 10.5938 11.3867C10.5938 11.9661 10.4766 12.4902 10.2422 12.959C10.0078 13.4277 9.67253 13.8281 9.23633 14.1602C8.80013 14.4922 8.27604 14.7493 7.66406 14.9316C7.05859 15.1074 6.38151 15.1953 5.63281 15.1953C4.97526 15.1953 4.32747 15.1042 3.68945 14.9219C3.05794 14.7396 2.48177 14.4661 1.96094 14.1016C1.44661 13.737 1.0332 13.2878 0.720703 12.7539C0.414714 12.2135 0.261719 11.5885 0.261719 10.8789H2.13672C2.13672 11.3672 2.23112 11.7871 2.41992 12.1387C2.60872 12.4837 2.86589 12.7702 3.19141 12.998C3.52344 13.2259 3.89779 13.3952 4.31445 13.5059C4.73763 13.61 5.17708 13.6621 5.63281 13.6621C6.29036 13.6621 6.84701 13.571 7.30273 13.3887C7.75846 13.2064 8.10352 12.946 8.33789 12.6074C8.57878 12.2689 8.69922 11.8685 8.69922 11.4062ZM16.9512 13.7109C17.3809 13.7109 17.778 13.623 18.1426 13.4473C18.5072 13.2715 18.8066 13.0306 19.041 12.7246C19.2754 12.4121 19.4089 12.0573 19.4414 11.6602H21.1602C21.1276 12.2852 20.916 12.8678 20.5254 13.4082C20.1413 13.9421 19.6367 14.375 19.0117 14.707C18.3867 15.0326 17.6999 15.1953 16.9512 15.1953C16.1569 15.1953 15.4635 15.0553 14.8711 14.7754C14.2852 14.4954 13.7969 14.1113 13.4062 13.623C13.0221 13.1348 12.7324 12.5749 12.5371 11.9434C12.3483 11.3053 12.2539 10.6315 12.2539 9.92188V9.51172C12.2539 8.80208 12.3483 8.13151 12.5371 7.5C12.7324 6.86198 13.0221 6.29883 13.4062 5.81055C13.7969 5.32227 14.2852 4.93815 14.8711 4.6582C15.4635 4.37826 16.1569 4.23828 16.9512 4.23828C17.778 4.23828 18.5007 4.40755 19.1191 4.74609C19.7376 5.07812 20.2227 5.53385 20.5742 6.11328C20.9323 6.6862 21.1276 7.33724 21.1602 8.06641H19.4414C19.4089 7.63021 19.2852 7.23633 19.0703 6.88477C18.862 6.5332 18.5755 6.25326 18.2109 6.04492C17.8529 5.83008 17.4329 5.72266 16.9512 5.72266C16.3978 5.72266 15.9323 5.83333 15.5547 6.05469C15.1836 6.26953 14.8874 6.5625 14.666 6.93359C14.4512 7.29818 14.2949 7.70508 14.1973 8.1543C14.1061 8.59701 14.0605 9.04948 14.0605 9.51172V9.92188C14.0605 10.3841 14.1061 10.8398 14.1973 11.2891C14.2884 11.7383 14.4414 12.1452 14.6562 12.5098C14.8776 12.8743 15.1738 13.1673 15.5449 13.3887C15.9225 13.6035 16.3913 13.7109 16.9512 13.7109ZM24.998 6.09375V15H23.1914V4.43359H24.9492L24.998 6.09375ZM28.2988 4.375L28.2891 6.05469C28.1393 6.02214 27.9961 6.0026 27.8594 5.99609C27.7292 5.98307 27.5794 5.97656 27.4102 5.97656C26.9935 5.97656 26.6257 6.04167 26.3066 6.17188C25.9876 6.30208 25.7174 6.48438 25.4961 6.71875C25.2747 6.95312 25.099 7.23307 24.9688 7.55859C24.8451 7.8776 24.7637 8.22917 24.7246 8.61328L24.2168 8.90625C24.2168 8.26823 24.2786 7.66927 24.4023 7.10938C24.5326 6.54948 24.7311 6.05469 24.998 5.625C25.265 5.1888 25.6035 4.85026 26.0137 4.60938C26.4303 4.36198 26.9251 4.23828 27.498 4.23828C27.6283 4.23828 27.778 4.25456 27.9473 4.28711C28.1165 4.31315 28.2337 4.34245 28.2988 4.375ZM29.2949 9.83398V9.60938C29.2949 8.84766 29.4056 8.14128 29.627 7.49023C29.8483 6.83268 30.1673 6.26302 30.584 5.78125C31.0007 5.29297 31.5052 4.91536 32.0977 4.64844C32.6901 4.375 33.3542 4.23828 34.0898 4.23828C34.832 4.23828 35.4993 4.375 36.0918 4.64844C36.6908 4.91536 37.1986 5.29297 37.6152 5.78125C38.0384 6.26302 38.3607 6.83268 38.582 7.49023C38.8034 8.14128 38.9141 8.84766 38.9141 9.60938V9.83398C38.9141 10.5957 38.8034 11.3021 38.582 11.9531C38.3607 12.6042 38.0384 13.1738 37.6152 13.6621C37.1986 14.1439 36.694 14.5215 36.1016 14.7949C35.5156 15.0618 34.8516 15.1953 34.1094 15.1953C33.3672 15.1953 32.6999 15.0618 32.1074 14.7949C31.515 14.5215 31.0072 14.1439 30.584 13.6621C30.1673 13.1738 29.8483 12.6042 29.627 11.9531C29.4056 11.3021 29.2949 10.5957 29.2949 9.83398ZM31.1016 9.60938V9.83398C31.1016 10.3613 31.1634 10.8594 31.2871 11.3281C31.4108 11.7904 31.5964 12.2005 31.8438 12.5586C32.0977 12.9167 32.4134 13.1999 32.791 13.4082C33.1686 13.61 33.6081 13.7109 34.1094 13.7109C34.6042 13.7109 35.0371 13.61 35.4082 13.4082C35.7858 13.1999 36.0983 12.9167 36.3457 12.5586C36.5931 12.2005 36.7786 11.7904 36.9023 11.3281C37.0326 10.8594 37.0977 10.3613 37.0977 9.83398V9.60938C37.0977 9.08854 37.0326 8.59701 36.9023 8.13477C36.7786 7.66602 36.5898 7.2526 36.3359 6.89453C36.0885 6.52995 35.776 6.24349 35.3984 6.03516C35.0273 5.82682 34.5911 5.72266 34.0898 5.72266C33.5951 5.72266 33.1589 5.82682 32.7812 6.03516C32.4102 6.24349 32.0977 6.52995 31.8438 6.89453C31.5964 7.2526 31.4108 7.66602 31.2871 8.13477C31.1634 8.59701 31.1016 9.08854 31.1016 9.60938ZM43.1426 0V15H41.3262V0H43.1426ZM48.0059 0V15H46.1895V0H48.0059Z" fill="white"/>
<defs>
<clipPath id="clip0_2_2">
<rect width="30.24" height="55" fill="white" transform="translate(9 27)"/>
</clipPath>
</defs>
</svg>

			</div>
		</div>
	</div>
</template>

<script>
	import Tooltip from './tooltip/';

	import Scenarios from './scenarios';
	import * as d3 from 'd3';

	import './index.scss';

export default {
	name: 'inkomsten',
	components: {Tooltip},
	data () {
		return {
			tooltip: undefined,
			showScroll: false,
			showClickLabel: false,
			showTooltip: false
		}
	},
	computed: {
		gemeente:function(){
			return this.$store.getters.selectedGemeente;
		},
		master:function(){
			return this.$store.getters.getMaster;
		} 		
	},
	mounted: function() {
		this.chart = new Scenarios({
			el: this.$refs.money,
			margin: {left: 5, right: 20, top: 20, bottom: 20}
		});

		this.chart.render();
	},
	watch: {
		'$store.state.currentStep': {
			deep: true,
				handler(newVal) {
				this.correctTopic(newVal);
			}
		},

		gemeente(newValue, oldValue) {
			// this.chart.renderClusteredCircles([])	
		}
	},
	methods: {
		showEindscherm() {
			this.$store.dispatch('showEndScreen');
			this.showScroll = true;
			this.showClickLabel = false;
		},

		ObjToArr(data) {
			let arr = [];
			for (const property in data) {
				arr.push({label: property, value: data[property]})
			}
			return arr;
		},

		correctTopic(obj) {			
			switch(obj.topic){
				case 'INKOMSTEN':
					this.renderInkomsten(obj.step);
					break;
				case 'THEMA':
					this.renderThema(obj);
					break;
				case 'SELECTEER':
					this.renderSelecteer(obj);
					break;

			}
		},

		renderSelecteer(obj) {
			let gemeente = this.gemeente;
			let lastenArr = this.ObjToArr(gemeente.lasten.jaar_2022);
			this.chart.resetHighlights();
			this.chart.renderClusteredCircles(lastenArr);

			for(var i = 0; i <= gemeente.history.length; i++) {
				this.chart.highLight('.knd-' + gemeente.history[i]);
			}

			this.enableMouseClick();
		},

		enableMouseClick() {
			let gemeente = this.gemeente;

			this.showClickLabel = true;
			this.chart.enableMouseClick((d, e) => {

				gemeente.history.push(e.label);

				let item = {label: e.label, value: gemeente.lasten.jaar_2022[e.label]};


				this.chart.renderClusteredCircles([item])
				this.chart.highLight('.knd-' + e.label);
				this.$store.dispatch('addThema', e.label);
				this.showClickLabel = false;
				this.showTooltip = false;

				this.$nextTick(() => {
					if(gemeente.history.length === 1) {
						var element = document.querySelector('.knd-step__explainer');
						element.scrollIntoView({block: "end", inline: "nearest"});
					} else {
						window.scrollTo(0, window.pageYOffset + 100)

					}
					document.addEventListener('scroll', (e) => {
						this.showScroll = false;
					});
				});
				this.showScroll = true;
			});

			this.chart.enableMouseOver(this.onShowTooltip, this.onHideTooltip)
		},

		onShowTooltip(event, d) {
			
			this.tooltip = {
				x: event.x,
				y: event.y,
				info: d
			};

			this.showTooltip = true;
		},

		onHideTooltip(event) {
			this.showTooltip = false;
		},

		renderThema(obj) {
			let gemeentes = this.$store.getters.gemeentenList;


			if(this.chart.scene !== 'BEESWARM') {
				this.chart.setup(gemeentes, {
					value: d => Number(d.lasten.jaar_2022[obj.title]),
					xLabel: obj.title,
					className: d => 'knd-circle knd-' + d.gemeente_code + ' knd-' + d.inwoners_categorie,
					rType: d3.scaleSqrt,
					rRange: [1, 15],
					rValue: d => d.aantal_inwoners
				});
				
				this.chart.setupBeeswarm();
			}

			this.showClickLabel = false;
			this.chart.resetHighlights();

			// set higlights if set by step
			if(obj.content && obj.content.highlight.length > 0) {
				let arr = obj.content.highlight.split(";");

				for(var i  = 0; i < arr.length; i++) {
					this.chart.highLightGemeente('.knd-' + arr[i]);
				}
			}

			switch(obj.step) {
				case 'START':
					this.chart.highLightGemeente('.knd-' + this.gemeente.gemeente_code);
					break;
				case 'GEMEENTE':

					this.chart.highLightGemeente('.knd-' + this.gemeente.gemeente_code);
					break;

				case 'UITSCHIETERS':
					break;
				case 'VERGELIJKEN': 
					this.chart.highLight('.knd-' + this.gemeente.inwoners_categorie);
					this.chart.highLightGemeente('.knd-' + this.gemeente.gemeente_code);
			}
		},

		renderInkomsten(step) {
			let gemeente = this.$store.getters.selectedGemeente;
			let batenArr = this.ObjToArr(gemeente.baten.jaar_2022);
			let lastenArr = this.ObjToArr(gemeente.lasten.jaar_2022);

			this.chart.resetHighlights();

			switch(step) {
				case 'START':
					this.chart.renderClusteredCircles(batenArr)	
					break;
				case 'RIJK':
					this.chart.highLight('.knd-gemeentefonds');
					this.chart.highLight('.knd-uitkering');
					break;
				case 'BELASTINGEN':
					this.chart.renderClusteredCircles(batenArr);
					this.chart.highLight('.knd-afval');
					this.chart.highLight('.knd-ozb');
					this.chart.highLight('.knd-burger');
					this.chart.highLight('.knd-parkeren');
					this.chart.highLight('.knd-belastingen');
					this.chart.highLight('.knd-riolering');
					this.chart.highLight('.knd-wonen');
					this.showClickLabel = false;
					break;
				case 'OVERIG':
					this.chart.highLight('.knd-overig');
					break;
				case "UITGAVEN":
					this.chart.renderClusteredCircles(lastenArr);

					if(gemeente.history.length > 0) {
						this.chart.disableSelect();
						this.chart.highLight('.knd-' + gemeente.history[0]);
					} else {
						this.enableMouseClick();
					}
			}
		}
	} 
}
</script>